<section class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section">
  <div
    *ngIf="isAdmin$ | async"
    class="ceil-article-item business-block-item ceil-add-item flex-column justify-content-center align-items-center"
    (click)="onCreateNewProject(); false"
  >
    <div class="add-icon">
      <svg viewBox="0 0 26 26">
        <use href="#add-icon"></use>
      </svg>
    </div>
    <div class="add-text">Create new club project or content</div>
  </div>

  <ng-container *ngIf="amountOfPages$ | async as amountOfPages; else noProjects">
    <app-paginator
      [currentPage]="currentPage"
      [amountOfPages]="amountOfPages"
      [navigation]="false"
      (setPage)="onSetPage($event)"
    >
      <div class="ceil-article-item business-block-item" *ngFor="let project of projects$ | async">
        <a [profile]="project.user" class="icon">
          <app-avatar [src]="project.user.icon" [placeholder]="project.user | initials" class="img-fluid"> </app-avatar>
        </a>
        <div class="ceil-content">
          <div class="ceil-text">
            <div class="ceil-tag">{{ project.type }}</div>
            <div class="ceil-title"> {{ project.title }} </div>
            <div class="ceil-category"> {{ project.topic }} </div>
            <div class="ceil-description" [innerHTML]="project.description"></div>
            <div class="ceil-actions">
              <a *ngIf="project.url" [href]="project.url | httpPrefix" target="_blank">Explore</a>
              <a *ngIf="project.article" [article]="project.article" target="_blank">Explore</a>
            </div>
          </div>
        </div>
        <div class="options d-flex" *ngIf="isAdmin$ | async">
          <div (click)="onEditProject(project); false">
            <svg viewBox="0 0 15 15">
              <use href="#sub-edit-post" />
            </svg>
          </div>
          <div (click)="onRemoveProject(project.id); false">
            <svg viewBox="0 0 15 15">
              <use href="#sub-delete" />
            </svg>
          </div>
        </div>
      </div>
    </app-paginator>
  </ng-container>
  <ng-template #noProjects>
    <div
      *ngIf="(isLoadingProjects$ | async) == false"
      class="ceil-article-item business-block-item ceil-stay-tuned flex-column justify-content-center align-items-center"
    >
      <div class="add-icon">
        <svg viewBox="0 0 25 25">
          <use href="#time" />
        </svg>
      </div>
      <div class="add-text"> Stay tuned for exclusive content for your clubs </div>
    </div>
  </ng-template>
</section>
